/**
 * Stack - Image FAQ JavaScript
 * Accordion functionality for FAQ items
 */

class StackFaqItem extends HTMLElement {
  constructor() {
    super();
    this.trigger = null;
    this.content = null;
    this.isExpanded = false;
  }

  connectedCallback() {
    this.trigger = this.querySelector('.stack-image-faq__trigger');
    this.content = this.querySelector('.stack-image-faq__content');

    if (this.trigger && this.content) {
      this.trigger.addEventListener('click', () => this.toggle());
      
      // Keyboard support
      this.trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggle();
        }
      });

      // Recalculate height when images load
      const images = this.content.querySelectorAll('img');
      images.forEach(img => {
        if (!img.complete) {
          img.addEventListener('load', () => this.calculateContentHeight());
        }
      });

      // Recalculate on window resize
      window.addEventListener('resize', () => {
        if (this.isExpanded) {
          this.calculateContentHeight();
        }
      });
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  expand() {
    this.calculateContentHeight();
    this.trigger.setAttribute('aria-expanded', 'true');
    this.content.setAttribute('aria-hidden', 'false');
  }

  collapse() {
    this.trigger.setAttribute('aria-expanded', 'false');
    this.content.setAttribute('aria-hidden', 'true');
  }

  calculateContentHeight() {
    // Get the inner content element
    const inner = this.content.querySelector('.stack-image-faq__content-inner');
    if (!inner) return;

    // Measure the actual height of the inner content
    const height = inner.scrollHeight + 24; // Add padding
    this.content.style.setProperty('--content-height', `${height}px`);
  }
}

if (!customElements.get('stack-faq-item')) {
  customElements.define('stack-faq-item', StackFaqItem);
}
